import { ButtonBase, Chip, styled } from '@mui/material';
import DESIGN_COLORS from 'shared/_ui/design-colors';

/** Tag chip of the new design: white rounded pill with a 1px border. */
export const TagChip = styled(Chip, { name: 'TagChip' })(({ theme }) => ({
	height: 'auto',
	border: `1px solid ${DESIGN_COLORS.border}`,
	borderRadius: '0.875rem',
	backgroundColor: theme.palette.background.paper,
	fontSize: '0.78125rem',
	fontWeight: 500,
	// `&.MuiChip-root` outranks the theme's default-color label rule.
	'&.MuiChip-root .MuiChip-label': {
		padding: theme.spacing(1.25, 3),
		color: DESIGN_COLORS.slate,
	},
	'&.MuiChip-root.MuiChip-deletable .MuiChip-label': { paddingRight: theme.spacing(1) },
	'& .MuiChip-deleteIcon': { margin: theme.spacing(0, 2, 0, 0) },
	'&.MuiChip-deletable:hover, &.MuiChip-deletable.Mui-focusVisible': {
		backgroundColor: DESIGN_COLORS.surfaceMuted,
	},
}));

/** Dashed pill button that starts adding a tag (shown by the read-only tag field). */
export const AddTagButton = styled(ButtonBase, { name: 'AddTagButton' })(({ theme }) => ({
	gap: theme.spacing(1),
	padding: theme.spacing(1.25, 3),
	border: `1px dashed ${DESIGN_COLORS.borderHover}`,
	borderRadius: '0.875rem',
	color: DESIGN_COLORS.muted,
	fontSize: '0.78125rem',
	fontWeight: 600,
	'&:hover': { borderColor: DESIGN_COLORS.muted, color: DESIGN_COLORS.strong },
	'& .MuiSvgIcon-root': { fontSize: '0.75rem' },
}));
